// extracted by mini-css-extract-plugin
module.exports = {"age":"LifestyleDescription_age__1ewY8","score":"LifestyleDescription_score__3SJD7"};